import Images from "styles/image-library";

export const getWalletIcon = (walletName: string | null | undefined) => {
  const name = walletName?.toLowerCase();
  if (name?.includes("phantom")) {
    return Images.logos_phantom_white;
  }
  if (name?.includes("solflare")) {
    return Images.logos_solflare_white;
  }
  if (name?.includes("coinbase")) {
    return Images.logos_coinbase_wallet_white;
  }

  return Images.icons_wallet;
};
